import { render, staticRenderFns } from "./liveReplay.vue?vue&type=template&id=1ec02f40&scoped=true"
import script from "./liveReplay.vue?vue&type=script&lang=js"
export * from "./liveReplay.vue?vue&type=script&lang=js"
import style0 from "./liveReplay.vue?vue&type=style&index=0&id=1ec02f40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec02f40",
  null
  
)

export default component.exports